import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IonicModule, NavParams } from '@ionic/angular';
import { AlertController, ModalController } from '@ionic/angular/standalone';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { DateFormatPipe } from 'src/app/pipes/date-format/date-format';
import { GrupoProvider } from 'src/app/services/grupo/grupo';
import { format, addDays } from 'date-fns';
import { GrupoGerenciarVisitantesAddPage } from '../grupo-gerenciar-visitantes-add/grupo-gerenciar-visitantes-add.page';
import { GrupoGerenciarParticipantesAddPage } from '../grupo-gerenciar-participantes-add/grupo-gerenciar-participantes-add.page';
import { ImagePipe } from 'src/app/pipes/image/image';
import { SemRegistroComponent } from 'src/app/components/sem-registro/sem-registro';
import { GrupoGerenciarSolicitacoesFiltroComponent } from './grupo-gerenciar-solicitacoes-filtro/grupo-gerenciar-solicitacoes-filtro.component';
import { GrupoGerenciarSolicitacoesAnotacaoPage } from './grupo-gerenciar-solicitacao-anotacao/grupo-gerenciar-solicitacao-anotacao.page';

@Component({
  selector: 'app-grupo-gerenciar-solicitacoes-adm',
  templateUrl: './grupo-gerenciar-solicitacoes-adm.page.html',
  styleUrls: ['./grupo-gerenciar-solicitacoes-adm.page.scss'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    DateFormatPipe,
    TranslateModule,
    ImagePipe,
    SemRegistroComponent,
  ],
})
export class GrupoGerenciarSolicitacoesAdmPage implements OnInit {
  idGrupo: string;
  solicitacoes: Array<any>;
  tipo: string;

  filtro = {
    dataInicio: format(new Date(), 'yyyy-MM-dd'),
    dataFim: format(addDays(new Date(), 30), 'yyyy-MM-dd'),
    status: 1,
  };

  constructor(
    public navParams: NavParams,
    public modalCtrl: ModalController,
    public grupoProvider: GrupoProvider,
    private translate: TranslateService,
    public alertCtrl: AlertController
  ) {
    this.tipo = this.navParams.get('tipo');
    this.idGrupo = this.navParams.get('idGrupo');
    this.loading();
  }

  ngOnInit() { }

  get solicitacoesVazias(): boolean {
    return Array.isArray(this.solicitacoes) && this.solicitacoes.length === 0;
  }

  loading() {
    this.grupoProvider
      .gerenciarSolicitacoes(this.idGrupo, this.filtro)
      .subscribe((result) => {
        this.solicitacoes = result;
      });
  }

  async adicionar(pessoa: any) {
    const titulo = await this.translate.get('Atenção!').toPromise();
    const nao = await this.translate.get('Não').toPromise();
    const participante = await this.translate.get('Participante').toPromise();
    const visitante = await this.translate.get('Visitante').toPromise();
    const sim = await this.translate.get('Sim').toPromise();
    const isVisitor = pessoa.idPessoaTipo === '5';
    const mensagem =
      (await this.translate
        .get('Deseja adicionar essa pessoa como ')
        .toPromise()) +
      (isVisitor ? visitante : participante) +
      '?';

    const buttons = [
      {
        text: sim,
        handler: () => {
          isVisitor
            ? this.addVisitantes(pessoa)
            : this.addParticipantes(pessoa);
        },
      },
      {
        text: nao,
      },
    ];

    const alert = await this.alertCtrl.create({
      cssClass: "alerta-personalizado",
      mode: "ios",
      header: titulo,
      message: mensagem,
      buttons: buttons,
    });

    await alert.present();
  }

  async addVisitantes(participante: any) {
    const data = {
      idGrupo: this.idGrupo,
      tipo: this.tipo,
      solicitacaoParticipante: participante,
    };

    const modalPage = await this.modalCtrl.create({
      component: GrupoGerenciarVisitantesAddPage,
      componentProps: data,
    });

    modalPage.present();

    const pessoa = await modalPage.onWillDismiss();
    if (pessoa.data) {
      this.atualizarStatus(participante.idSolicitacao);
    }
  }

  async addParticipantes(participante: any) {
    const data = {
      idGrupo: this.idGrupo,
      tipo: this.tipo,
      solicitacaoParticipante: participante,
    };

    const modalPage = await this.modalCtrl.create({
      component: GrupoGerenciarParticipantesAddPage,
      componentProps: data,
    });

    modalPage.present();

    const pessoa = await modalPage.onWillDismiss();
    if (pessoa.data) {
      this.atualizarStatus(participante.idSolicitacao);
    }
  }

  async anotacao(idSolicitacao: any) {
    const modalPage = await this.modalCtrl.create({
      component: GrupoGerenciarSolicitacoesAnotacaoPage,
    });
    modalPage.present();

    const result = await modalPage.onWillDismiss();
    if (result.data) {
      this.finalizar(idSolicitacao, result.data.anotacao);
    }
  }


  atualizarStatus(idSolicitacao: number, anotacao = null) {
    this.grupoProvider.atualizarStatus(idSolicitacao, anotacao).subscribe((result) => {
      !result.error ? this.loading() : this.alert();
    });
  }

  async finalizar(idSolicitacao: number, anotacao = null) {
    const titulo = await this.translate.get('Atenção').toPromise();
    const mensagem = await this.translate
      .get(
        'A solicitação administrativa será finalizada. Você tem certeza que deseja prosseguir?'
      )
      .toPromise();
    const nao = await this.translate.get('Não').toPromise();
    const sim = await this.translate.get('Sim').toPromise();

    const alert = await this.alertCtrl.create({
      cssClass: "alerta-personalizado",
      mode: "ios",
      header: titulo,
      message: mensagem,
      buttons: [
        {
          text: sim,
          handler: () => {
            this.atualizarStatus(idSolicitacao, anotacao);
          },
        },
        {
          text: nao,
          role: 'cancel',
        },
      ],
    });

    await alert.present();
  }

  async alert(
    message: string = 'Não foi possível incluir o participante',
    title: string = 'Erro'
  ) {
    const titulo = await this.translate.get(title).toPromise();
    const mensagem = await this.translate.get(message).toPromise();
    const fechar = await this.translate.get('Fechar').toPromise();

    const alert = await this.alertCtrl.create({
      cssClass: "alerta-personalizado",
      mode: "ios",
      header: titulo,
      message: mensagem,
      buttons: [
        {
          text: fechar,
        },
      ],
    });

    await alert.present();
  }

  async filtrar() {
    const data = { filtro: this.filtro };
    const modalPage = await this.modalCtrl.create({
      component: GrupoGerenciarSolicitacoesFiltroComponent,
      componentProps: data,
    });
    modalPage.present();

    const filtro = await modalPage.onWillDismiss();
    if (filtro.data) {
      this.filtro = filtro.data;

      this.grupoProvider
        .gerenciarSolicitacoes(this.idGrupo, this.filtro)
        .subscribe((result) => {
          this.solicitacoes = result;
        });
    }
  }

  openOption() {
    return;
  }

  public closeModal() {
    this.modalCtrl.dismiss();
  }
}
